import SkillMatrixComp from '../../Components/SkillMatrix/SkillMatrixComp';

function SkillMatrix() {
  return <SkillMatrixComp />;
}

export default SkillMatrix;
